export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty-d942f95fe7cbd38d14d78d55af6ae981.png";